(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-nailo-gallery]:not([data-nailo-gallery-ready])').forEach(gallery => {
      gallery.dataset.nailoGalleryReady = 'true';
      const track = gallery.querySelector('[data-nailo-gallery-track]');
      const slides = Array.from(gallery.querySelectorAll('[data-nailo-slide]'));
      const thumbnails = Array.from(gallery.querySelectorAll('[data-nailo-thumbnail]'));
      const strip = gallery.querySelector('[data-nailo-thumbnails]');
      if (!track || slides.length < 2) return;
      let active = 0;
      let scheduled = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const center = element => {
        const rect = element.getBoundingClientRect();
        return rect.left + rect.width / 2;
      };
      const markActive = index => {
        active = index;
        thumbnails.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
        const button = thumbnails[index];
        if (!strip || !button) return;
        const item = button.getBoundingClientRect();
        const bounds = strip.getBoundingClientRect();
        if (item.left < bounds.left || item.right > bounds.right) {
          strip.scrollBy({ left: center(button) - center(strip), behavior: 'auto' });
        }
      };
      const select = (index, behavior = reducedMotion.matches ? 'auto' : 'smooth') => {
        index = Math.max(0, Math.min(slides.length - 1, index));
        markActive(index);
        track.scrollBy({ left: center(slides[index]) - center(track), behavior });
      };
      thumbnails.forEach((button, index) => button.addEventListener('click', () => select(index)));
      gallery.querySelectorAll('[data-nailo-gallery-step]').forEach(button => {
        button.addEventListener('click', () => {
          const step = Number(button.dataset.nailoGalleryStep);
          select((active + step + slides.length) % slides.length);
        });
      });
      track.addEventListener('scroll', () => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          const middle = center(track);
          let nearest = 0;
          slides.forEach((slide, index) => {
            if (Math.abs(center(slide) - middle) < Math.abs(center(slides[nearest]) - middle)) nearest = index;
          });
          if (nearest !== active) markActive(nearest);
        });
      }, { passive: true });
      track.addEventListener('keydown', event => {
        const rtl = getComputedStyle(track).direction === 'rtl';
        const steps = { ArrowLeft: rtl ? 1 : -1, ArrowRight: rtl ? -1 : 1 };
        if (event.key in steps || event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          select(event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : active + steps[event.key]);
        }
      });
      const resizeObserver = new ResizeObserver(() => select(active, 'auto'));
      resizeObserver.observe(track);
      gallery.addEventListener('shopify:section:unload', () => resizeObserver.disconnect(), { once: true });
    });
    root.querySelectorAll('[data-nailo-product]:not([data-nailo-ready])').forEach(section => {
      section.dataset.nailoReady = 'true';
      const sticky = section.nextElementSibling;
      const box = section.querySelector('.n-buy-box');
      if (!sticky?.matches('[data-nailo-sticky]') || !box) return;
      const update = () => {
        const rect = box.getBoundingClientRect();
        sticky.hidden = rect.bottom > 0;
      };
      const observer = new IntersectionObserver(update, { threshold: [0, 1] });
      observer.observe(box);
      window.addEventListener('scroll', update, { passive: true });
      update();
    });
  };
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.target === '_blank') return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== location.origin || url.pathname !== location.pathname || !['#nailo-buy', '#nailo-bundles'].includes(url.hash)) return;
    const target = document.getElementById('nailo-bundles');
    if (!target) return;
    event.preventDefault();
    const header = document.querySelector('.n-header');
    const headerBottom = Math.max(0, header?.getBoundingClientRect().bottom || 0);
    const top = Math.max(0, target.getBoundingClientRect().top + window.scrollY - headerBottom - 16);
    target.focus({ preventScroll: true });
    window.scrollTo({ top, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
